// SSOT for billing intervals supported by Stripe
export const PLAN_INTERVALS = ['day', 'week', 'month', 'year'] as const
export type PlanInterval = (typeof PLAN_INTERVALS)[number]

export const PLAN_INTERVAL_LABEL: Record<PlanInterval, string> = {
  day: 'Diário',
  week: 'Semanal',
  month: 'Mensal',
  year: 'Anual',
}

export type Plan = {
  id: string
  slug: string
  name: string
  description: string | null
  features: string[]
  amount_cents: number
  currency: string
  interval: PlanInterval
  visible: boolean
  active: boolean
  stripe_product_id?: string | null
  stripe_price_id?: string | null
  meta?: Record<string, any>
}

// Timeframes canônicos (SSOT) para limites
export const TF_KEYS = ['5','15','30','60','240','720','D','W','M'] as const
export type TimeframeKey = (typeof TF_KEYS)[number]

export type OpportunityLimitsMode = 'unlimited' | 'fixed'
export type OpportunityCycle = Exclude<PlanInterval, 'year'> // day|week|month

export type OpportunityLimits = {
  active_cycle: OpportunityCycle
  mode: OpportunityLimitsMode
  total?: number
  allocations?: Partial<Record<TimeframeKey, number>>
}
